var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("Steps", {
              attrs: {
                stepInfo: _vm.statusNode,
                statustype: _vm.auditStatus.status,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "contentDetails",
          staticStyle: { display: "flex", "justify-content": "space-between" },
        },
        [
          _vm.statusNode.status !== 1
            ? _c("div", [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "8px" },
                      attrs: { src: require("../../assets/icon_wanc.png") },
                    }),
                    _c("span", { staticClass: "boldSize" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.statusNode.status == 2
                              ? "备货中，等待卖家备货"
                              : "" ||
                                _vm.statusNode.status == 3 ||
                                _vm.statusNode.status == 4
                              ? "已备货，等待商家发货"
                              : "" || _vm.statusNode.status == 5
                              ? "等待买家确认签收"
                              : "" || _vm.statusNode.status == 6
                              ? "买家已签收"
                              : "" || _vm.statusNode.status == 7
                              ? "已取消"
                              : "" || _vm.statusNode.status == 1
                              ? "等待买家付款"
                              : "" || _vm.statusNode.status == 99
                              ? "异常订单，待处理"
                              : ""
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
                _vm.statusNode.status == 99
                  ? _c("div", { staticClass: "approver" }, [
                      _vm._v(" 异常订单，待平台处理！ "),
                    ])
                  : _c("div", { staticClass: "approver" }, [
                      _vm._v("收货信息"),
                    ]),
                _vm.statusNode.status == 3 || _vm.statusNode.status == 4
                  ? _c(
                      "p",
                      {
                        staticClass: "size14",
                        staticStyle: { "margin-top": "6px" },
                      },
                      [_vm._v(" 使用物流配送 ")]
                    )
                  : _vm._e(),
                _vm.statusNode.status == 3 ||
                _vm.statusNode.status == 4 ||
                _vm.statusNode.status == 5 ||
                _vm.statusNode.status == 6
                  ? _c(
                      "p",
                      {
                        staticClass: "size14",
                        staticStyle: { "margin-top": "6px" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.orderMessage.logisticsCompanyLabel)
                          ),
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "padding-left": "10px" } },
                          [_vm._v(_vm._s(_vm.orderMessage.logisticsNumber))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.statusNode.status == 1
            ? _c("div", [
                _c("div", { staticClass: "surTime" }, [
                  _c("div", { staticClass: "surTime-title" }, [
                    _vm._v("买家剩余支付时间"),
                  ]),
                  _c("div", { staticClass: "surTime-time" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("倒计时")]),
                    _c("div", { staticClass: "sur-content" }, [
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.stayHour)),
                      ]),
                      _c("div", { staticClass: "splice" }, [_vm._v(":")]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.stayMin)),
                      ]),
                      _c("div", { staticClass: "splice" }, [_vm._v(":")]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.staySec)),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "logisticsBtn" },
            [
              _vm.statusNode.status == 5 || _vm.statusNode.status == 6
                ? _c(
                    "el-button",
                    { staticClass: "whiteBtn", on: { click: _vm.examine } },
                    [_vm._v("查看物流")]
                  )
                : _vm._e(),
              _vm.statusNode.status == 4 &&
              (_vm.parArray.indexOf("deliverGoodsCode") != -1 ||
                _vm.parArrayTwo.indexOf("wuliu_deliverGoodsCode") != -1) &&
              _vm.orgName == "物流中心"
                ? _c(
                    "el-button",
                    { staticClass: "whiteBtn", on: { click: _vm.shipments } },
                    [_vm._v("发 货")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          {
            staticClass: "title",
            staticStyle: { display: "flex", "align-items": "center" },
          },
          [
            _vm._v(" 订单信息 "),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "saleAfterType" }, [
                  _vm._v(" " + _vm._s(_vm.orderMessage.orderTypeLabel) + " "),
                ])
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "order_details" }, [
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单编号"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderNo ? _vm.orderMessage.orderNo : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单类型"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderTypeLabel
                      ? _vm.orderMessage.orderTypeLabel
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _vm._m(1),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("支付时间"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(_vm._s(_vm.statusNode.payTime || "-")),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "remarkMessage" }, [
          _c("div", { staticClass: "remarkMessage_remark" }, [
            _c("div", { staticClass: "remarkMessage_remark_item" }, [
              _c("span", { staticClass: "fourteenTitle" }, [
                _vm._v("备注信息"),
              ]),
              _c("span", { staticClass: "fourteenDetails" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.userRemark
                      ? _vm.orderMessage.userRemark
                      : "暂无备注 "
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("购买信息")]),
        _c("div", { staticClass: "contentDetails_box" }, [
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("收货信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货人"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.orderMessage.postName
                        ? _vm.orderMessage.postName
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("联系方式"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.orderMessage.postPhone
                        ? _vm.orderMessage.postPhone
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item addressWidth" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货地址"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(_vm.orderMessage.postDistrictAddress) +
                      " " +
                      _vm._s(_vm.orderMessage.postAddress)
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "borderWire" }),
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("买家信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户姓名"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.orderMessage.userName
                        ? _vm.orderMessage.userName
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户电话"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.orderMessage.userPhone
                        ? _vm.orderMessage.userPhone
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("来源平台"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.orderMessage.platformLabel
                        ? _vm.orderMessage.platformLabel
                        : "-"
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "contentDetails" },
        [
          _vm._m(2),
          _c("ordersListDetailTable", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.orderDetailList1,
              config: _vm.columnCommon.config,
            },
          }),
          _c("div", { staticClass: "fourteenDetails_title" }, [
            _vm._v("优惠信息"),
          ]),
          _vm.orderMessage.discountLabel
            ? _c("div", [
                _c("p", [_vm._v(_vm._s(_vm.orderMessage.discountLabel))]),
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass: "fourteenDetails",
                    staticStyle: {
                      "margin-top": "12px",
                      "border-bottom": "1px solid #ededed",
                      "padding-bottom": "20px",
                    },
                  },
                  [_vm._v(" 无优惠 ")]
                ),
              ],
          _vm.orderDetailList2.length != 0
            ? _c("div", { staticClass: "titleBtn" }, [_vm._m(3)])
            : _vm._e(),
          _vm.orderDetailList2.length != 0
            ? _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.orderDetailList2,
                    "header-cell-style": {
                      background: "#fafafa",
                      color: "#333333",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "updatedTime",
                      label: "商品信息",
                      headerAlign: "left",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          props.row.goodsName
                                            ? props.row.goodsName
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        props.row.goodsSkuName
                                          ? props.row.goodsSkuName
                                          : "-"
                                      )
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " 商品编码：" +
                                        _vm._s(
                                          props.row.goodsSkuNo
                                            ? props.row.goodsSkuNo
                                            : "-"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1904138149
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "单价/数量",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "￥" +
                                        _vm._s(
                                          props.row.retailPrice ||
                                            props.row.unitPrice
                                        )
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "× " + _vm._s(props.row.goodsQuantity)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2302092149
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "小计",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "实付￥" + _vm._s(props.row.totalAmount)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3525961125
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "total_prices" }, [
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [
                _vm._v(
                  "商品总价：￥" +
                    _vm._s(
                      _vm.orderMessage.goodsAmount
                        ? Number(_vm.orderMessage.goodsAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [
                _vm._v(
                  "运费：￥" +
                    _vm._s(
                      _vm.orderMessage.freightAmount
                        ? Number(_vm.orderMessage.freightAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "red", "margin-right": "15px" } },
              [
                _vm._v(
                  "优惠：￥" +
                    _vm._s(
                      _vm.orderMessage.discountAmount
                        ? Number(_vm.orderMessage.discountAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "fontWeight",
                staticStyle: { color: "#444", "margin-right": "15px" },
              },
              [
                _vm._v(
                  "应付：￥" +
                    _vm._s(
                      _vm.orderMessage.receivableAmount
                        ? Number(_vm.orderMessage.receivableAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticClass: "fontWeight", staticStyle: { color: "#6190ed" } },
              [
                _vm._v(
                  "（实付：￥" +
                    _vm._s(
                      _vm.orderMessage.receivableAmount &&
                        !(
                          _vm.orderMessage.status == 1 ||
                          _vm.orderMessage.status == 7
                        )
                        ? Number(_vm.orderMessage.receivableAmount).toFixed(2)
                        : "0.00"
                    ) +
                    "）"
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "botton_btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "logisticsInformation"
            ? [
                _c("StepLogistics", {
                  attrs: { stepProgress: _vm.logisticsNode },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "shipmentsCode"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "wuliu",
                    attrs: {
                      model: _vm.wuliu,
                      rules: _vm.wuliuRules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "出库仓库",
                          "label-width": "100px",
                          prop: "warehouse",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择出库仓库",
                            },
                            model: {
                              value: _vm.wuliu.warehouse,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "warehouse", $$v)
                              },
                              expression: "wuliu.warehouse",
                            },
                          },
                          _vm._l(_vm.commWarehouseList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流公司",
                          "label-width": "100px",
                          prop: "company",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择物流公司",
                            },
                            model: {
                              value: _vm.wuliu.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "company", $$v)
                              },
                              expression: "wuliu.company",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.courier_company,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流单号",
                          "label-width": "100px",
                          prop: "odd",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^\\w_]/g,'')",
                          },
                          model: {
                            value: _vm.wuliu.odd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.wuliu,
                                "odd",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "wuliu.odd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmitwuliu("wuliu")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addAddress"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货人姓名",
                          "label-width": "100px",
                          prop: "userName",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.userName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "userName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.userName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "联系电话",
                          "label-width": "100px",
                          prop: "phone",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^0-9.]/g,'')",
                            maxLength: 11,
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货地址",
                          "label-width": "100px",
                          prop: "addressValue",
                        },
                      },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.addressOptions,
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.onChangeAddress },
                          model: {
                            value: _vm.form.addressValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "addressValue", $$v)
                            },
                            expression: "form.addressValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "详细地址",
                          "label-width": "100px",
                          prop: "detailedAddress",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.detailedAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "detailedAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.detailedAddress",
                          },
                        }),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { "false-label": 0, "true-label": 1 },
                            model: {
                              value: _vm.form.isDefault,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isDefault", $$v)
                              },
                              expression: "form.isDefault",
                            },
                          },
                          [_vm._v("设为默认 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmit("form")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addRemark"
            ? [
                _c(
                  "el-form",
                  { attrs: { "label-width": "50px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 5,
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.remark,
                            callback: function ($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialogBtn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmAddRemark },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addressAmend"
            ? [
                _c(
                  "span",
                  { staticClass: "addressHeader" },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: { color: "#4168e7" },
                    }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4168e7" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.addAddress("Address")
                          },
                        },
                      },
                      [_vm._v("新增收货地址")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.siteDataList,
                      "header-cell-style": {
                        background: "#F8F8F9",
                        color: "#333333",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "收货人", prop: "userName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "手机号码", prop: "phone" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "地区", prop: "userName" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.provinceCode
                                          ? props.row.provinceCode +
                                              props.row.cityCode +
                                              props.row.regionCode
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        197606537
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "详细地址", prop: "detailedAddress" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "默认地址" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.defaultSite(props.row.id)
                                    },
                                  },
                                  model: {
                                    value: props.row.isDefault,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "isDefault", $$v)
                                    },
                                    expression: "props.row.isDefault",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        234956708
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.employ(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("使用 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogEdit(
                                          "editAddress",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogDelete(props.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除 ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1854051084
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogToo.title,
            visible: _vm.dialogToo.visible,
            width: _vm.dialogToo.width,
            "append-to-body": "",
            "before-close": _vm.handleCloseToo,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogToo, "visible", $event)
            },
          },
        },
        [
          _vm.dialogToo.type == "selectPay"
            ? [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectPayment },
                    model: {
                      value: _vm.setPay.payment,
                      callback: function ($$v) {
                        _vm.$set(_vm.setPay, "payment", $$v)
                      },
                      expression: "setPay.payment",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("在线支付"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "setPayDialogBtn" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.selectPayDefault },
                          model: {
                            value: _vm.setPay.payDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.setPay, "payDefault", $$v)
                            },
                            expression: "setPay.payDefault",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "1", name: "type" } },
                            [_vm._v("设为默认")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmSelectPay },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "payMoney"
            ? [
                _c("div", { staticClass: "payMoney" }, [
                  _c("div", [
                    _c("p", { staticClass: "payMoney_should" }, [
                      _vm._v(
                        " 应付:￥" +
                          _vm._s(_vm.orderMessage.receivableAmount) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "payMoney_already" }, [
                      _vm._v("已收:￥200.00"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "payMoney_box" },
                    [
                      _c("span", { staticClass: "payMoney_money" }, [
                        _vm._v("支付金额"),
                      ]),
                      _c("span", { staticClass: "payMoney_mo" }, [
                        _vm._v("￥"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "110px" },
                        attrs: {
                          controls: false,
                          mix: 0,
                          type: "number",
                          precision: 2,
                        },
                        model: {
                          value: _vm.paymentAmount,
                          callback: function ($$v) {
                            _vm.paymentAmount = $$v
                          },
                          expression: "paymentAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "payMoney_text" }, [
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("总计: 共" + _vm._s(_vm.totalQuantity) + "件"),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("商品总价: ￥" + _vm._s(_vm.totalPrices)),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "运费: ￥" + _vm._s(_vm.orderMessage.freightAmount)
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "dialogBtnright" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.onlinePayment },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "closeOrder"
            ? [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.setCloseOrder,
                      callback: function ($$v) {
                        _vm.setCloseOrder = $$v
                      },
                      expression: "setCloseOrder",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_main_close_reason,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName))]
                      )
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "audit"
            ? [
                _c("div", { staticClass: "audit_title" }, [
                  _vm._v("是否审核通过？"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.handlerSelect },
                    model: {
                      value: _vm.selectShenhe,
                      callback: function ($$v) {
                        _vm.selectShenhe = $$v
                      },
                      expression: "selectShenhe",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "2" } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: "3" } }, [
                      _vm._v("不通过"),
                    ]),
                  ],
                  1
                ),
                _vm.selectShenhe == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "audit_textarea",
                            attrs: { "label-width": "40px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入原因",
                                    maxlength: "200",
                                    "show-word-limit": "",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.cause,
                                    callback: function ($$v) {
                                      _vm.cause = $$v
                                    },
                                    expression: "cause",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerAuditsubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialogafterSaleClass",
          attrs: {
            title: _vm.dialogAfterSale.title,
            visible: _vm.dialogAfterSale.visible,
            width: _vm.dialogAfterSale.width,
            "before-close": _vm.handleshouhouClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogAfterSale, "visible", $event)
            },
          },
        },
        [
          _vm.dialogAfterSale.type == "afterSale"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v("售后"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.applyDialog },
                      },
                      [_vm._v("申请售后")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.goodsListDialog,
                      "header-cell-style": {
                        background: "#fafafa",
                        color: "#333333",
                      },
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { color: "#fff" },
                                    attrs: { label: scope.$index },
                                    nativeOn: {
                                      change: function ($event) {
                                        return _vm.getCurrentRow(scope.row)
                                      },
                                    },
                                    model: {
                                      value: _vm.multipleSelection,
                                      callback: function ($$v) {
                                        _vm.multipleSelection = $$v
                                      },
                                      expression: "multipleSelection",
                                    },
                                  },
                                  [_c("span", [_vm._v(" ")])]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        47093805
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "updatedTime",
                        label: "商品信息",
                        headerAlign: "left",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            props.row.goodsName
                                              ? props.row.goodsName
                                              : "-"
                                          )
                                        ),
                                      ]),
                                      props.row.goodsType == "3"
                                        ? _c("span", { staticClass: "gift" }, [
                                            _vm._v("赠品"),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row.goodsSkuName
                                              ? props.row.goodsSkuName
                                              : "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " 商品编码：" +
                                          _vm._s(
                                            props.row.goodsNo
                                              ? props.row.goodsNo
                                              : "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1237664513
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "单价/数量",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "￥" + _vm._s(props.row.unitPrice)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("x" + _vm._s(props.row.quantity)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1824988655
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "小计",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "实付￥" + _vm._s(props.row.amountPaid)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("￥" + _vm._s(props.row.subtotal)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2425156658
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "其他信息",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    props.row.subsetStatus != "售后关闭" &&
                                    props.row.status != 0
                                      ? _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row.statusCn) +
                                              ":￥" +
                                              _vm._s(props.row.refundMoney) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    props.row.subsetStatus
                                      ? _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                props.row.subsetStatus ==
                                                  "无售后"
                                                  ? "-"
                                                  : props.row.subsetStatus
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    props.row.subsetStatus != "售后关闭" &&
                                    props.row.afterSaleReason
                                      ? _c("p", [
                                          _vm._v(
                                            " 售后原因:" +
                                              _vm._s(
                                                props.row.afterSaleReason
                                                  ? props.row.afterSaleReason
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1842814966
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogAfterSale.type == "applyAfterSale"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v("售后"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.ruleForm, rules: _vm.rulesRuleForm },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "退款类型", prop: "afterType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm.afterType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "afterType", $$v)
                              },
                              expression: "ruleForm.afterType",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.after_type,
                            function (item, index) {
                              return _c(
                                "el-radio",
                                { key: index, attrs: { label: item.dictId } },
                                [_vm._v(_vm._s(item.dictName))]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "售后原因", prop: "afterSaleReason" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择活动区域" },
                            model: {
                              value: _vm.ruleForm.afterSaleReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "afterSaleReason", $$v)
                              },
                              expression: "ruleForm.afterSaleReason",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.after_sale_reason,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "290px" },
                        attrs: { prop: "refundMoney", "label-width": "100px" },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(" 退款金额（最多"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.afterMoney)),
                            ]),
                            _vm._v("元） "),
                          ]
                        ),
                        _c("el-input", {
                          attrs: { placeholder: "请输入退款金额" },
                          on: {
                            input: (v) =>
                              (_vm.ruleForm.refundMoney = v.replace(
                                /^(\d*\.?\d{0,2}).*/,
                                "$1"
                              )),
                          },
                          model: {
                            value: _vm.ruleForm.refundMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "refundMoney", $$v)
                            },
                            expression: "ruleForm.refundMoney",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "退款说明（选填）",
                          prop: "refundExplain",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入退款说明",
                            maxlength: "200",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.refundExplain,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "refundExplain", $$v)
                            },
                            expression: "ruleForm.refundExplain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "上传凭证（选填）最多3张",
                          prop: "appendixList",
                        },
                      },
                      [
                        _c("upload-picture", {
                          attrs: {
                            limit: 3,
                            "file-list": _vm.ruleForm.appendixList,
                          },
                          on: {
                            getUrl: _vm.getUrl,
                            handleRemove: _vm.handleRemove,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handledeleteClose },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.submitAfterSale("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogAfterSale.type == "record"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v(_vm._s(_vm.dialogAfterSale.title)),
                    ]),
                  ]
                ),
                _c("lb-table", {
                  attrs: {
                    column: _vm.columnRecord,
                    data: _vm.transactionRecord,
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contentDetails" }, [
      _c("div", { staticClass: "titleBtn" }, [
        _c("div", { staticClass: "title titleblue" }, [_vm._v("订单详情")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "order_details_box" }, [
      _c("div", { staticClass: "order_details_item" }, [
        _c("span", { staticClass: "order_details_title" }, [
          _vm._v("支付方式"),
        ]),
        _c("span", { staticClass: "order_details_value" }, [
          _vm._v("在线支付"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "titleBtn" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "margin-bottom": "20px" } },
        [_c("label", [_vm._v("商品信息")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "title",
        staticStyle: { "margin-bottom": "20px", "margin-top": "20px" },
      },
      [_c("label", [_vm._v("赠品商品")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }